export type Faq = { q: string; a: string };

export const faqs: Faq[] = [
  {
    q: "黑瓜爆料的「追踪」和普通爆料有什么区别？",
    a: "普通爆料通常只发布一次，后续进展往往没有下文。我们为每一条线索建立独立时间线，从首次流出开始，后续的回应、澄清与反转都会追加到同一条记录里，读者打开就能看到完整脉络。",
  },
  {
    q: "你们的信息来源可靠吗？会核实吗？",
    a: "我们要求至少两个相互独立的信源指向同一事实，才会把它标记为已核实。暂时只有单一信源的内容会被明确标注为待核实，并在时间线中用不同颜色区分，不与已核实节点混在一起。",
  },
  {
    q: "当事人没有回应，是不是就说明爆料是真的？",
    a: "不是。我们会如实标注「暂未回应」，但这只是状态描述，不代表承认，也不代表默认成立。沉默的原因可能有很多，我们不把它当作任何结论的依据。",
  },
  {
    q: "如果后续信息推翻了你们之前的判断怎么办？",
    a: "我们会保留原始节点，并在同一条时间线里追加更正说明，说明是哪个节点被证伪、依据是什么。我们不通过删除内容来掩盖判断失误，「改在明处」是我们内容原则的一部分。",
  },
  {
    q: "普通人可以提交线索吗？会被采纳吗？",
    a: "可以。你可以通过页面底部的联系方式把线索发给我们。请在提交时尽量附上原始出处与时间点，越具体的材料越有助于我们判断。我们不承诺每条线索都会发布，但会认真核对。",
  },
  {
    q: "为什么有些内容只有寥寥几句话？",
    a: "当一条线索刚流出、证据尚不充分时，我们宁可写得少，也不愿用推测把篇幅撑满。随着节点增加，这条时间线会自然长出更完整的叙述。",
  },
  {
    q: "网站上的图片和内容可以转载吗？",
    a: "欢迎在注明出处并附上原文链接的前提下转载。请勿对标题与结论部分进行改写，因为表述方式的细微改动很容易造成与原意相反的解读。",
  },
];